import Skeleton from '@mui/material/Skeleton';
import Grid from '@mui/material/Grid';
import GridContainerWrapper from '../../shared/GridContainerWrapper';

const PasswordAndSecurityFlowSkeletonLayout = ({ mainComponent = false }) => {
	return (
		<GridContainerWrapper>
			<Grid item xs={12}>
				<Skeleton
					data-testid="skeleton-loading-avatar"
					variant="circular"
					width={50}
					height={50}
				/>
			</Grid>
			<Grid item xs={12}>
				<Skeleton
					data-testid="skeleton-loading-rectangle"
					variant="rectangular"
					height={252}
				/>
			</Grid>
			{mainComponent && (
				<Grid item xs={12}>
					<Skeleton
						data-testid="skeleton-loading-rectangle"
						variant="rectangular"
						height={285}
					/>
				</Grid>
			)}
		</GridContainerWrapper>
	);
};

export default PasswordAndSecurityFlowSkeletonLayout;
